import React, { useState } from 'react';
import './Portfolio.css';

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const portfolioItems = [
    {
      id: 1,
      title: "Portrait of Sarah",
      category: "portraits",
      description: "Detailed pencil portrait from photo reference",
      image: "/profile.png",
      featured: true
    },
    {
      id: 2,
      title: "Nature Study",
      category: "sketches",
      description: "Charcoal sketch of forest landscape",
      image: "/profile.png",
      featured: false
    },
    {
      id: 3,
      title: "Digital Illustration",
      category: "digital",
      description: "Modern digital art piece",
      image: "/profile.png",
      featured: true
    },
    {
      id: 4,
      title: "Family Portrait",
      category: "portraits",
      description: "Group portrait in pencil",
      image: "/profile.png",
      featured: false
    },
    {
      id: 5,
      title: "Abstract Sketch",
      category: "sketches",
      description: "Experimental pencil work",
      image: "/profile.png",
      featured: false
    },
    {
      id: 6,
      title: "Character Design",
      category: "digital",
      description: "Fantasy character illustration",
      image: "/profile.png",
      featured: true
    }
  ];

  const categories = [
    { id: 'all', name: 'All Work' },
    { id: 'portraits', name: 'Portraits' },
    { id: 'sketches', name: 'Sketches' },
    { id: 'digital', name: 'Digital Art' }
  ];

  const filteredItems = activeCategory === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <section id="portfolio" className="section portfolio">
      <div className="container">
        <div className="section-title">
          <h2>My Portfolio</h2>
          <p>Explore my latest artwork and creative projects</p>
        </div>

        <div className="portfolio-filters">
          {categories.map(category => (
            <button
              key={category.id}
              className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {filteredItems.map((item, index) => (
            <div 
              key={item.id} 
              className={`portfolio-item ${item.featured ? 'featured' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="portfolio-image">
                <img src={item.image} alt={item.title} />
                <div className="portfolio-overlay">
                  <div className="portfolio-content">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <button className="view-btn">View Details</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="portfolio-cta">
          <h3>Interested in a Custom Piece?</h3>
          <p>Let's discuss your vision and create something amazing together</p>
          <button 
            className="btn"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Start Your Project
          </button>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
